import { Component, computed, effect, inject, signal, OnInit } from '@angular/core';
import { Router, RouterModule, RoutesRecognized } from '@angular/router';
import { Allgemein } from '../grundlagen/allgemein';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { FormsModule, NgModel } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { HierarchyBindingDirective, MenuModule, MenusModule } from '@progress/kendo-angular-menu';
import { GrunddatenService } from '../grundlagen/grunddaten.service';
import { environment } from '../../environment';
import { RefreshTokenService } from '../auth/refresh-token.service';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UiBestaetigungComponent } from '../shared/ui/bestaetigung.component';
import { AuswahlDD } from '../grundlagen/AuswahlDD';
import { HttpClient } from '@angular/common/http';
import { chevronDoubleDownIcon, chevronDoubleUpIcon, filePdfIcon, questionCircleIcon, youtubeIcon } from '@progress/kendo-svg-icons';
import { KENDO_ICONS } from '@progress/kendo-angular-icons';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { CommonModule } from '@angular/common';
import { VideosComponent } from '../anwendung/hilfe/videos/videos.component';
import { uiPopupComponent } from '../shared/ui/popup/ui-popup.component';
import { BenutzerRollen } from '../grundlagen/benutzerrollen';
import { MenuInfo } from '../auth/menu';
import { UiSpinnerComponent } from '../shared/ui/ui-spinner';

@Component({
  selector: 'app-navbar',
  imports: [
    RouterModule,
    DropDownsModule,
    ButtonsModule,
    MenusModule,
    FormsModule,
    LabelModule,
    MenuModule,
    UiBestaetigungComponent,
    KENDO_ICONS,
    DialogsModule,
    IndicatorsModule,
    CommonModule,
    VideosComponent,
    uiPopupComponent,
    UiSpinnerComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  providers: [NgModel, HierarchyBindingDirective, MenuModule],
})
export class NavbarComponent implements OnInit {
  private httpClient = inject(HttpClient);
  protected allgemein = inject(Allgemein);
  private router = inject(Router);
  protected grunddaten = inject(GrunddatenService);
  private rts = inject(RefreshTokenService);
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  private urlAusschluss: string[] = ['/system/benutzer/edit', '/login', '/logout', '/passwortanfordern', '/passwortneu', '/loginWVA'];

  protected rlist = signal<AuswahlDD[]>([]);
  protected slist = signal<AuswahlDD[]>([]);

  pdfVisible = signal(false);
  videoVisible = signal(false);
  pdfUrl: SafeResourceUrl | null = null;
  hatDaten = signal<boolean>(false);
  reportgeneriert = signal<boolean>(true);

  constructor() {
    effect(() => {
      this.router.events.subscribe((data) => {
        if (data instanceof RoutesRecognized) {
          if (this.urlMitDaten(data.url)) {
            this.firmaFehlt.set(this.grunddaten.firmaFehlt());
          }
        }
      });
    });

    effect(() => {
      this.rlist.set(this.grunddaten.reguliererList());
      this.entwickler.set(this.grunddaten.benutzerHatRecht(BenutzerRollen.Entwickler));
    });

    effect(() => {
      this.slist.set(this.grunddaten.stationenList());
    });
  }

  public icons = { pdf: filePdfIcon, video: youtubeIcon, hilfe: questionCircleIcon, up: chevronDoubleUpIcon, down: chevronDoubleDownIcon };

  stationReset() {
    this.grunddaten.setIdStation(0);
  }
  stationLetzte() {
    if (this.grunddaten.letzteIdStation() > 0) {
      this.grunddaten.setIdStation(this.grunddaten.letzteIdStation());
    }
  }
  ngOnInit() {
    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized || data.type == 1) {
        if (this.urlMitDaten(data.url)) {
          this.rts.readBenutzerDaten().subscribe();
        }
        if (data.url === '/popup') {
          this.compNews.set('newsAnzeigen');
          this.router.navigate(['/']);
        }
      }
    });
  }

  protected firmaFehlt = signal<boolean>(false);

  entwickler = signal<boolean>(false);

  urlMitDaten(url: string): boolean {
    let daten = true;
    this.urlAusschluss.forEach((element) => {
      if (url.startsWith(element)) {
        daten = false;
      }
    });
    return daten;
  }

  checkStammdaten() {
    this.router.navigateByUrl('/system/benutzer/edit');
  }

  isProduction = computed(() => {
    if (environment.baseUrl() == environment.productionURL) {
      return '#F6A22D';
    } else {
      return 'lightblue';
    }
  });

  protected loginClick(): void {
    this.router.navigate(['/login']);
  }

  protected logoutClick(): void {
    this.router.navigate(['/logout']);
  }

  protected hilfeClick(): void {
    this.showPdf();
  }

  showPdf() {
    this.pdfVisible.set(true);
    this.reportgeneriert.set(false);
    this.hatDaten.set(false);

    const hilfe = this.router.url;
    const url = environment.baseUrl() + 'hilfe/anzeige?url=' + hilfe;
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
        this.hatDaten.set(true);
        this.reportgeneriert.set(true);
      },
      error: (err) => {
        // console.error('Fehler beim Abrufen des Dokuments', err.message);
        this.reportgeneriert.set(true);
      },
    });
  }

  closePDF() {
    this.pdfVisible.set(false);
    this.pdfUrl = null;
  }

  closeVideoHelp() {
    this.videoVisible.set(false);
  }

  videoClick() {
    //window.open('/hilfe/videos', '_blank');
    this.videoVisible.set(true);
  }

  compNews = signal<string>('');

  protected onSelect(e: any): void {
    this.grunddaten.sperreRS.set(false);
    const item = e.item;
    if (!item.items || item.items.length === 0) {
      // Sonderfall Aktuelles als Popup
      if (item.text == 'Aktuelles') {
        e.preventDefault();
        this.compNews.set('newsAnzeigen');
      } else if (item.url != '') {
        // 1. Zerlege die URL mit dem URL-Konstruktor
        const url = new URL(item.url, window.location.origin);

        const notificationCount = item.notificationCount;

        if (notificationCount > 0) {
          this.aktualisiereMenuInfo(item.id);
        }

        // 2. Extrahiere Pfad und Parameter
        const path = url.pathname;
        const queryParams: any = {};
        url.searchParams.forEach((value, key) => {
          queryParams[key] = value;
        });

        // 3. Navigiere korrekt
        this.router.navigate([path], { queryParams });
      }
    }
  }

  private aktualisiereMenuInfo(id: number) {
    this.httpClient.get<MenuInfo[]>(environment.baseUrl() + `grundlagen/menuinfoupdate?id=${id}&reguliererid=${this.grunddaten.idRegulierer()}`).subscribe({
      next: () => {
        this.grunddaten.fetchNotificationCounts();
      },
      error: (err) => {
        // console.log('Error: ' + err.message);
      },
    });
  }

  protected filterRegulierer(value: string) {
    this.rlist.set(this.grunddaten.reguliererList().filter((s) => s.bezeichnung.toLowerCase().indexOf(value.toLowerCase()) !== -1));
  }

  protected filterStation(value: string) {
    this.slist.set(this.grunddaten.stationenList().filter((s) => s.bezeichnung.toLowerCase().indexOf(value.toLowerCase()) !== -1));
  }
}
